import { useState, useEffect, ComponentProps } from "react";
import { Input } from "~/components/ui/input";
import { useDebounce } from "~/util/hooks";

type Props = Omit<ComponentProps<typeof Input>, "value" | "onChange"> & {
  value: string;
  onChange: (value: string) => void;
};

const BouncedTextInput = (props: Props) => {
  const { value: propValue, onChange: propOnChange, ...rest } = props;
  const [value, setValue] = useState(propValue ? propValue : "");
  useEffect(() => {
    if (!propValue) {
      setValue("");
    } else if (value !== propValue) {
      setValue(propValue);
    }
  }, [propValue]);
  const onChange = useDebounce(() => {
    propOnChange(value);
  }, 1000);
  return (
    <Input
      {...rest}
      value={value}
      onChange={(e) => {
        setValue(e.target.value);
        onChange();
      }}
    />
  );
};

export default BouncedTextInput;
